// src/api/salesReportsApi.js
import api from './api';

export const getSalesDashboard = (params = {}) =>
  api.get('/sales-reports/dashboard', { params });

export const getSalesSummary = (params = {}) =>
  api.get('/sales-reports/summary', { params });

export const getTotalSales = (params = {}) =>
  api.get('/sales-reports/totals', { params });

export const getSalesBySalesperson = (params = {}) =>
  api.get('/sales-reports/by-salesperson', { params });

export const getSalesByProduct = (params = {}) =>
  api.get('/sales-reports/by-product', { params });

export const getSalesByCustomer = (params = {}) =>
  api.get('/sales-reports/by-customer', { params });

export const getInactiveCustomers = (params = {}) =>
  api.get('/sales-reports/inactive-customers', { params });

const salesReportsApi = {
  getSalesDashboard,
  getSalesSummary,
  getTotalSales,
  getSalesBySalesperson,
  getSalesByProduct,
  getSalesByCustomer,
  getInactiveCustomers,
};

export default salesReportsApi;
